import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  margin: 0 1.5rem;
`;

export const RulesBanner = styled.div`
  flex-shrink: 0;
  color: var(--text-primary, #222);
  background: var(--background-main, #fafafa);
  border-bottom: 1px solid var(--divider, #E0E0E0);
  font-size: 0.85rem;
  line-height: 1.3rem;
  ol { margin: 0.35rem 0.75rem; padding-left: 1.1rem; }
  li { margin-bottom: 0.2rem; }
`;

export const RulesToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 1rem;
  background: none;
  border: none;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary, #222);
  cursor: pointer;
`;

export const RulesBody = styled.div<{ open?: boolean }>`
  overflow: hidden;
  max-height: ${p => p.open ? '300px' : '0'};
  transition: max-height 0.25s ease;
  padding: ${p => p.open ? '0 1rem 0.5rem' : '0 1rem'};
`;

export const MessagesViewport = styled.div`
  flex: 1 1 0;
  min-height: 0;
  overflow: auto;
  padding: 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 768px) {
    padding: 1rem;
  }
`;

export const DayDivider = styled.div`
  text-align: center;
  color: var(--text-secondary, #666);
  font-size: 0.85rem;
  margin: 0.5rem 0;
`;

export const Row = styled.div<{ align: 'left'|'right' }>`
  display: flex;
  width: 100%;
  justify-content: ${p => p.align === 'right' ? 'flex-end' : 'flex-start'};
`;

export const Bubble = styled.div<{ mine?: boolean }>`
  max-width: min(75%, 560px);
  white-space: pre-line;
  word-wrap: break-word;
  border-radius: 14px;
  padding: 0.5rem 0.6rem 0.35rem 0.6rem;
  background: ${p => p.mine ? 'var(--primary-blue, #0B4598)' : '#fff'};
  color: ${p => p.mine ? '#fff' : 'var(--text-primary, #222)'};
  border: 1px solid var(--divider, #E0E0E0);
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);

  .name { font-size: 0.8rem; opacity: 0.85; margin-bottom: 2px; }
  .text { font-size: 0.95rem; }
  .meta { display: flex; gap: 6px; align-items: center; justify-content: flex-end; margin-top: 4px; opacity: ${p => p.mine ? 0.9 : 0.7}; font-size: 0.78rem; }
`;

export const ComposerBar = styled.div`
  flex-shrink: 0;
  border-top: 1px solid var(--divider, #E0E0E0);
  padding: 0.5rem 1rem;
  background: var(--background-main, #fafafa);
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom, 0));
`;

export const ComposerInput = styled.textarea`
  flex: 1 1 auto;
  resize: none;
  max-height: 200px;
  min-height: 40px;
  border: 1px solid var(--divider, #E0E0E0);
  border-radius: 10px;
  padding: 0.5rem 0.6rem;
  font-family: inherit;
  font-size: 0.95rem;
  background: #fff;

  &:disabled {
    background: #f3f4f6;
    color: #6b7280;
    cursor: not-allowed;
  }
`;

export const SendButton = styled.button`
  flex: 0 0 auto;
  border: 1px solid var(--primary-blue, #0B4598);
  background: var(--primary-blue, #0B4598);
  color: #fff;
  padding: 0.55rem 0.9rem;
  border-radius: 10px;
  font-weight: 600;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;


